import React from 'react';
import './kovin.css';

const SanjeebKumarMishra  = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/sanjeeb mishra.png" alt="Sanjeeb Kumar Mishra " />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Sanjeeb Kumar Mishra</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">

            Sanjeeb Kumar Mishra is one of the finest optometrists who have significantly contributed to the profession of 
            ptometry in Nepal. Mr. Sanjeeb has gathered a number of academic accolades to his name. He graduated as an optometrist 
            from the Institute of Medicine, Tribhuvan University, Nepal in 2004. Following B.Optom, he obtained his Masters Degree 
            from the Lotus College of Optometry, India. In 2010, he went on to pursue a certification in Orthokeratology from Boston, U.S.A.
            <br /><br />

            Ever since his graduation, Mr. Sanjeeb has been associated with multiple educational platforms. He worked as a qualified 
            optometrist at Kathmandu University Teaching hospital, Nepal in 2005, following which he served as an optometry faculty 
            member at the B.P. Koirala Lions Centre for Ophthalmic Studies (BPKLCOS). He has been arranging clinical postings & class 
            schedules for the B.Optom Program in Nepal since 2006. In the past decade, he was also proactively involved in promoting 
            the community outreach program of BPKLCOS, and has been a member of the “Healthy Eye Project for School Students of Kathmandu 
            Valley” project. Currently, he is appointed as an Assistant Professor and Program Coordinator of the B.Optom program.
            <br /><br />

            Mr. Sanjeeb has been involved in a plethora of research projects. Some of his notable research works include “Visual 
            status of the drivers involved in road traffic accident (RTA)”; “The effects of soft contact lens wear on corneal thickness, 
            curvature and surface regularity” and “Effectiveness of measuring the central field with the Berkeley field test.” 
            He has also served as a member of the editorial board of the scientific journal “The Sight.” Additionally, 
            he is a proactive member of the Nepalese Association of Optometrist (NAO) since 2004 while he also served 
            as the President of NAO from 2014-18. He is a Board member of the Nepal Health Professional Council as well 
            as a lifetime member of Nepal Netra Jyoti Sangh since 2018. He also served as the distinguished chairperson of 
            the first All Nepal Optometry Conference – an international conference held at Kathmandu on 5th Oct 2018, in which 
            several national and international delegates participated promptly.
            <br /><br />  

            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
       <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default SanjeebKumarMishra 